/* eslint-disable jsx-a11y/label-has-associated-control */
import { Box, Button, Divider } from "@mui/material";
import { Form, Formik } from "formik";
import { FC, useCallback, useState } from "react";
import { useDispatch } from "react-redux";

import Loading from "web/Layout/Common/Loading";
import __ from "web/Layout/Translations";

import FieldMUI from "web/Components/Common/Form/Field/fieldMUI";

import editForm from "web/utils/page/product/subscription/forms/editForm";
import { validateField } from "web/utils/system/formValidator/validation";

import {
  FormView,
  ISubscriptionReceiver,
  ISubscriptionReceiverFormValues,
  SubscriptionFormFieldType,
} from "web/types/Subscription";

import {
  setNotificationError,
  setNotificationSuccess,
} from "web/features/app/appSlice";
import { invalidateCurrentUserSubscription } from "web/features/subscriptions/subscriptionsApiSlice";

interface IEditEmailProps {
  receiver: ISubscriptionReceiver;
  benefitUUID: string;
  closeModal: () => void;
  isMobile: boolean;
}

const EditEmailMUI: FC<IEditEmailProps> = ({
  receiver,
  benefitUUID,
  closeModal,
  isMobile,
}) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const initialValues = {
    [SubscriptionFormFieldType.RECEIVER_EMAIL]:
      receiver.form.receiverEmail ?? "",
  };
  const onSuccessFunction = () => {
    setLoading(false);
    invalidateCurrentUserSubscription(dispatch);
    dispatch(
      setNotificationSuccess({
        message: __("Adres e-mail został poprawnie zmieniony."),
      })
    );
    closeModal();
  };
  const onErrorFunction = () => {
    setLoading(false);
    dispatch(
      setNotificationError({ message: __("Nie udało się wysłać formularza.") })
    );
  };
  const submitHandler = useCallback(
    (values: ISubscriptionReceiverFormValues) => {
      setLoading(true);

      editForm({
        receiverId: receiver.id,
        receiverEmail: values.receiverEmail as string,
        receiverType: receiver.type,
        subscriptionId: benefitUUID,
        viewType: FormView.MY_SUBSCRIPTIONS,
        onSuccess: onSuccessFunction,
        onError: onErrorFunction,
      });
    },
    []
  );

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        <Formik
          initialValues={initialValues}
          onSubmit={submitHandler}
          validate={(values) => {
            const emailKey = SubscriptionFormFieldType.RECEIVER_EMAIL;
            const msg = validateField(["required", "email"])(
              values[emailKey] as string,
              values
            );
            return msg ? { [emailKey]: msg } : {};
          }}
        >
          <Form>
            <FieldMUI
              name={SubscriptionFormFieldType.RECEIVER_EMAIL}
              type="email"
              label="E-mail"
            />
            <Divider sx={{ mb: 2, mt: 1 }} />
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                mt: 2,
                flexDirection: isMobile ? "column" : "row",
              }}
            >
              <Button
                variant="outlined"
                color="primary"
                size="large"
                onClick={closeModal}
                fullWidth={isMobile}
                sx={{ mr: 1, order: isMobile ? 1 : 0, mt: isMobile ? 2 : 0 }}
              >
                {__("Anuluj")}
              </Button>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                size="large"
                fullWidth={isMobile}
                sx={{ order: isMobile ? 0 : 1 }}
              >
                {__("Wyślij")}
              </Button>
            </Box>
          </Form>
        </Formik>
      )}
    </>
  );
};

export default EditEmailMUI;
